import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh; // This takes the full height of the viewport
  text-align: center;
  background-color: var(--color-grey-100);
`;

const Image = styled.img`
  max-width: 80%;
  height: auto;
  margin-bottom: 2rem; // Space between image and text
`;

const TextBox = styled.div`
  font-size: 5em;
  color: var(--color-grey-800); // Example color
`;

function PageNotFound() {
  return (
    <Container>
      <Image src="/images/PageNotFound.png" alt="Page Not Found" />
      <TextBox>PAGE NOT FOUND</TextBox>
    </Container>
  );
}

export default PageNotFound;
